module.exports = __webpack_public_path__ + "img/icon_map_water_lixian1.cce7d4fe.svg";